module.exports = __webpack_public_path__ + "img/img.90b953d0.png";